import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelOtherIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 32 32"
      >
        <rect
          width="32"
          height="32"
          rx="4"
          fill="none"
        />
        <path
          d="M16.9375 15.0645L30.0625 15.0645V30.0645H16.9375L16.9375 15.0645Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.5 18.8145H26.3125"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6875 22.5645H26.3125"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6875 26.3145H26.3125"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1924 26.2785C10.9489 26.1058 8.79706 25.3153 6.97521 23.9948C5.15335 22.6742 3.73265 20.875 2.87051 18.7966C2.00837 16.7182 1.73846 14.4417 2.09066 12.2193C2.44287 9.99689 3.40345 7.91538 4.86598 6.20538C6.32851 4.49538 8.23588 3.22365 10.3768 2.53109C12.5177 1.83853 14.8085 1.75218 16.9955 2.2816C19.1824 2.81102 21.1801 3.93555 22.7673 5.5306C24.3544 7.12564 25.4689 9.12892 25.9874 11.3185"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.43748 25.3745C9.43748 25.3745 8.09787 21.4905 9.43748 19.7495C9.92765 19.1125 10.6987 19.1745 11.025 18.4395C11.1253 18.214 11.173 17.9686 11.1643 17.7219C11.1557 17.4752 11.0909 17.2337 10.975 17.0158L9.40123 14.0595C9.23043 13.7402 9.00412 13.5075 8.62676 13.3403C8.24941 13.173 7.92505 13.1616 7.57373 13.2495L1.94873 14.652"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5625 3.855L7.5625 8.795C7.56174 9.15805 7.68257 9.5109 7.90573 9.79727C8.12889 10.0836 8.44152 10.287 8.79375 10.375L11.1688 11.1875C11.4086 11.2474 11.6589 11.2518 11.9007 11.2003C12.1425 11.1489 12.3694 11.0429 12.5641 10.8906C12.7587 10.7382 12.9161 10.5435 13.0241 10.3211C13.1321 10.0988 13.188 9.8547 13.1875 9.6075C13.1875 9.6075 12.9934 8.53645 13.1875 7.8975C13.7864 5.9264 18.3925 7.04 18.3925 7.04C18.7718 6.9767 19.1164 6.78094 19.3649 6.48752C19.6135 6.1941 19.7499 5.82204 19.75 5.4375V3.3125"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
